import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

/**
 * Primary UI component for user interaction
 */
export const Heading = ({ children, h1 = false, h2 = false, h3 = false, h4 = false, h5 = false, classes = null, ...props }) => {
  if(h1) return (<h1 className={classes}>{children}</h1>);
  if(h2) return (<h2 className={classes}>{children}</h2>);
  if(h3) return (<h3 className={classes}>{children}</h3>);
  if(h4) return (<h4 className={classes}>{children}</h4>);
  return (<h5 className={classes}>{children}</h5>);
};

Heading.propTypes = {

  /**
   * Text of heading
   */
   children: PropTypes.string.isRequired,

  /**
   * is this a h1?
   */
  h1: PropTypes.bool,
  
  /**
   * is this a h2?
   */
  h2: PropTypes.bool,
  
  /**
   * is this a h3?
   */
  h3: PropTypes.bool,
  
  /**
   * is this a h4?
   */
  h4: PropTypes.bool,
  
  /**
   * is this a h5?
   */
  h5: PropTypes.bool,
  classes: PropTypes.string,
};

